import { render, staticRenderFns } from "./InheemsIntro.vue?vue&type=template&id=189048c1&"
import script from "./InheemsIntro.vue?vue&type=script&lang=js&"
export * from "./InheemsIntro.vue?vue&type=script&lang=js&"
import style0 from "./InheemsIntro.vue?vue&type=style&index=0&id=189048c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports